<template>
    <div>
        <v-btn-toggle v-model="selectedTestTypes" multiple>
            <v-btn
                    active-class="error white--text"
                    v-for="type in testTypes"
                    :key="type.uuid"
                    :value="type.uuid"
            >
                {{type.name}}
            </v-btn>
        </v-btn-toggle>
        <v-btn @click="reloadReqs" icon><v-icon>mdi-refresh</v-icon></v-btn>
    </div>
</template>

<script>
    export default {
        name: "SampleTestSelection",
        data: () => ({
           selectedTestTypes: [],
        }),
        props:{
            sample_cert_type:{
                required:false,
            },
            imperatives:{
                required: false,
            }
        },
        watch:{
            imperatives(v){
                this.loadImperatives();
            },
            sample_cert_type(v){
                if(v){
                    this.loadRequirements(v)
                }
            }
        },
        computed:{
            testTypes(){
                let types = this.$store.$db().model('sampleTestTypes').all();
                let filtered = this.$store.state.filtered_test_types || [];
                if (filtered.length === 0) return types;
                return types.filter(type => !filtered.includes(type.uuid));
            },
            tests(){
                let unit = this.$store.$db().model('units').query().where('name', 'g').first()
                return this.selectedTestTypes.map(type => {
                    return {
                        uuid: null,
                        sample_uuid: null,
                        sample_test_type_uuid: type,
                        mass: 0,
                        unit_uuid: unit.uuid,
                        passed: false,
                        complete: false,
                        retest: false,
                        active: true,
                        created_by: this.$store.getters.id,
                        updated_by: this.$store.getters.id,
                        type: this.$store.$db().model('sampleTestTypes').find(type).name
                    }
                })
            }
        },
        methods:{
            reloadReqs(){
                this.selectedTestTypes = [];
                this.loadImperatives();
                this.loadRequirements(this.sample_cert_type)
            },
            loadImperatives(){
                if(this.imperatives.length === 0){
                    this.selectedTestTypes = [];
                    this.loadRequirements(this.sample_cert_type)
                    return;
                }
                let imperatives = this.imperatives;
                this.testTypes.forEach(type => {
                   if(!this.selectedTestTypes.includes(type.uuid)){
                       if(imperatives.some(imp => imp.imperative_type.desc.toLowerCase().includes(type.description.toLowerCase()))){
                            this.selectedTestTypes.push(type.uuid);
                       }
                   }
                });
            },
            loadRequirements(v){
                if(v){
                    v.requirements.forEach(req => {
                        if(!this.selectedTestTypes.includes(req.sample_test_type_uuid)){
                            this.selectedTestTypes.push(req.sample_test_type_uuid)
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>
